export const FilterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        d="M3.60091 1.39844H12.4009C13.1343 1.39844 13.7343 1.99844 13.7343 2.73177V4.19844C13.7343 4.73178 13.4009 5.39844 13.0676 5.73178L10.2009 8.26511C9.80092 8.59845 9.53426 9.26512 9.53426 9.79845V12.6651C9.53426 13.0651 9.26759 13.5985 8.93426 13.7985L8.00092 14.3985C7.13425 14.9318 5.93425 14.3318 5.93425 13.2651V9.73178C5.93425 9.26512 5.66758 8.66512 5.40092 8.33178L2.86758 5.66511C2.53425 5.33178 2.26758 4.73178 2.26758 4.33178V2.79844C2.26758 1.99844 2.86758 1.39844 3.60091 1.39844Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.28667 1.39844L4 6.66511"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
